import React, { useMemo } from "react";
import { Heart, Sparkles } from "lucide-react";

const PETAL_COLORS = ["#F7A8C4", "#F48FB1", "#F06292", "#FBBBD0", "#EC8AAE"];
const HEART_COLORS = ["#E8577A", "#F06292", "#D6446B", "#F48FB1", "#E24A78"];

export const FallingOverlay = ({ count = 18, variant = "petals" }) => {
  const items = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: 10 + Math.random() * 12,
        delay: -Math.random() * 12,
        duration: 8 + Math.random() * 8,
        sway: 20 + Math.random() * 45,
        color: (variant === "hearts" ? HEART_COLORS : PETAL_COLORS)[i % 5],
      })),
    [count, variant]
  );

  return (
    <div className="petal-layer" aria-hidden="true" data-testid="falling-overlay" data-variant={variant}>
      {items.map((p) => {
        const style = {
          left: `${p.left}%`,
          animationDelay: `${p.delay}s, ${p.delay}s`,
          animationDuration: `${p.duration}s, ${p.duration / 2}s`,
          "--sway": `${p.sway}px`,
        };
        if (variant === "hearts") {
          return (
            <span key={p.id} className="fall-item" style={style}>
              <Heart size={p.size + 6} fill={p.color} color={p.color} />
            </span>
          );
        }
        if (variant === "sparkles") {
          return (
            <span key={p.id} className="fall-item sparkle-item" style={style}>
              <Sparkles size={p.size + 6} color="#E7C255" fill="#F4D77A" />
            </span>
          );
        }
        return (
          <span key={p.id} className="fall-item petal" style={{ ...style, width: p.size, height: p.size, background: p.color }} />
        );
      })}
    </div>
  );
};

export const CherryBlossom = (props) => <FallingOverlay variant="petals" {...props} />;
